// extracted by mini-css-extract-plugin
export default {"container":"SL-z","timeTop":"TL-z","timeCountdown":"UL-z","cta":"VL-z","disabled":"WL-z","product":"XL-z"};